import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  conpanyDetailsRoot: {
    display: "flex",
    width: "1400px",
    padding: theme.spacing(3),
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.spacing(3),
    alignSelf: "stretch",

    borderRadius: "4px",
    background: "#FFF",
    boxShadow:
      "0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)",
  },
  pageHeader: {
    display: "flex",
    width: "1352px",
    justifyContent: "space-between",
    alignItems: "flex-start",
    alignSelf: "stretch",
  },
  cellDesign: {
    width: "calc((100% - 48px) / 3)", // 3 columns, 24px gap twice
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  companyName: {
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "32.016px",
  },
  textPrimary: {
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20.02px",
    letterSpacing: "0.17px",
    marginTop: "4px",
  },
  textSecondary: {
    color: "rgba(0, 0, 0, 0.60)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20.02px",
    letterSpacing: "0.15px",
    overflowWrap: "anywhere",
  },
  monthlyRefresh: {
    display: "flex",
    alignItems: "center",
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20.02px",
    letterSpacing: "0.17px",
    marginTop: "4px",
  },
  cicleWithText: {
    marginRight: "4px",
  },
  floatRight: {
    position: "relative",
    right: -20,
  },
  paper: {
    display: "flex",
    justifyContent: "flex-end",
  },
  editButton: {
    border: "1px 0px 0px 0px",
    width: "75px",
    height: "30px",
    padding: "4px 10px 4px 10px",
    gap: "0px",
    opacity: "0px",
    color: "#2196F3",
  },
  innerRow: {
    display: "flex",
    gap: "3px",
    paddingRight: "10px",
  },
  redDot: {
    fontSize: "0.8em !important",
    color: "red",
    marginRight: "4px",
  },
  grayDot: {
    fontSize: "0.8em !important",
    color: "lightgray",
    marginRight: "4px",
  },
  greenDot: {
    fontSize: "0.8em !important",
    color: "green",
    marginRight: "4px",
  },
  codatConnection: {
    display: "flex",
    alignItems: "center",
  },
  detailsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(3),
  },
  infoIcon: {
    width: "16px",
    height: "16px",
    flexShrink: 0,
    fill: "#000",
  },
   // Active Status
  activeChip: {
    textTransform: 'capitalize',
    backgroundColor: '#2E7D32',
    color: 'white',
  },
  activeIcon: {
    width: "16px",
    height: "16px",
    flexShrink: 0,
    fill: '#FFF',
  },
  
  // Inactive Status
  inactiveChip: {
    textTransform: 'capitalize',
    backgroundColor: 'rgba(0, 0, 0, 0.08));',
  },
  inactiveIcon: {
    width: "16px",
    height: "16px",
    flexShrink: 0,
    fill: 'rgba(0, 0, 0, 0.08))',
  },

  companyNameContainer: {
    display: "flex",
    flexDirection: "column",
    width: "1277px",
  },
  
  // Pending Renewal Status
  pendingRenewalChip: {
    textTransform: 'capitalize',
    backgroundColor: '#EF6C00',
    color: 'white',
    '&.MuiChip-outlined': {
      borderColor: '#EF6C00',
      color: 'white',
    },
  },
  pendingRenewalIcon: {
    width: "16px",
    height: "16px",
    flexShrink: 0,
    fill: '#FFF',
  },
  pdsTitle:{
  color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
  fontFeatureSettings: "'liga' off, 'clig' off",
  fontFamily: "Inter",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "266%",
  letterSpacing: "1px",
  textTransform: "uppercase",
  textAlign: "center",
  },

  //PDS Unavailability Banner
  pdsDetailsUnavailable: {
    width: "1138px",
    height: "48px",
    maxWidth: "1400px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderRadius: "4px",
    padding: "6px 16px",
    color: "#FDEDED",
    "& .MuiAlert-icon": {
      width: "34px",
      height: "36px",
      padding: "7px 12px 7px 0px",
      margin: "0px"
    },
    marginBottom: "8px"
  },
  pdsDetailsUnavailableIconContainer: {
    display: "flex",
    alignItems: "center"
  },
  pdsDetailsUnavailableIcon: {
    width: "22px",
    height: "22px",
    color: "#D32F2F",
  },
  pdsDetailsUnavailableTextContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "1072px",
    height: "36px",
    gap: "4px",
    paddingTop: "8px",
    paddingBottom: "8px",
  },
  pdsDetailsUnavailableText: {
    width: "1072px",
    height: "20px",
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "143%",
    letterSpacing: "0.17px",
    color: "#5F2120",
    whiteSpace: "nowrap"
  },

}));
